<div class="col-sm" *ngIf="route.children.length === 0">
    <div class="row">
        <div class="col-sm-3">
                <app-parent-card
                    [parent]="parent"
                    [data]="parentContent" ></app-parent-card>
        </div>
        <div class="col-xs-12 col-sm-9">
                <div class="row">
                    <div class="col align-middle options-bars">
                            <h1 class="float-start font-text" style="margin: 0px; padding: 0px;">{{viewTitle}}</h1>
                            <div class="button-container">
                                <div *ngIf="!isPois || isNulledLabel">
                                    <button
                                        mat-stroked-button
                                        color="accent"
                                        class="button-categories float-end font-text"
                                        [routerLink]="['./add']"
                                    >
                                        Agregar Categoría
                                        <mat-icon>add_circle</mat-icon>
                                    </button>
                                </div>
                                <div *ngIf="isPois || isNulledLabel">
                                    <button
                                        mat-stroked-button
                                        color="accent"
                                        class="button-categories float-end font-text"
                                        style="margin-left:5px;"
                                        (click)=openDialogLogs()
                                    >
                                        Logs de Carga
                                        <mat-icon>folder_open</mat-icon>
                                    </button>
                                </div>
                                <div *ngIf="isPois || isNulledLabel">
                                    <button
                                        mat-stroked-button
                                        color="accent"
                                        class="button-categories float-end font-text"
                                        style="margin-left:5px;"
                                        [routerLink]="['./add-pois']"
                                    >
                                        Agregar Punto de Interés
                                        <mat-icon>add_circle</mat-icon>
                                    </button>
                                </div>
                            </div>
                    </div>
                </div>
                <app-categories
                    [initialDataSourceData]="parentContent" [id]="childCategoryId"
                    [columns]="displayedColumns"
                    [category]="isPois ? 'poi' : 'category'"
                    [listPois]="isPois"
                >
                </app-categories>
        </div>
    </div>
</div>

<router-outlet></router-outlet>